export class MfaApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Get MFA status for current user.
     */
    async getStatus() {
        return this.client.get('/api/mfa/status');
    }
    /**
     * Get all MFA credentials for current user.
     */
    async getCredentials() {
        return this.client.get('/api/mfa/credentials');
    }
    /**
     * Start TOTP setup - returns secret and QR code URL.
     */
    async setupTotp(name) {
        return this.client.post('/api/mfa/totp/setup', { name: name || 'Authenticator' });
    }
    /**
     * Verify and activate TOTP with code from authenticator app.
     */
    async verifyTotp(credentialId, code) {
        return this.client.post('/api/mfa/totp/verify', { credentialId, code });
    }
    /**
     * Delete a TOTP credential.
     */
    async deleteTotp(credentialId) {
        return this.client.delete(`/api/mfa/totp/${credentialId}`);
    }
    /**
     * Start WebAuthn registration.
     */
    async startWebAuthnRegistration(name) {
        return this.client.post('/api/mfa/webauthn/register/start', { name: name || 'Passkey' });
    }
    /**
     * Complete WebAuthn registration.
     */
    async finishWebAuthnRegistration(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response, name) {
        return this.client.post('/api/mfa/webauthn/register/finish', { response, name });
    }
    /**
     * Rename a WebAuthn credential.
     */
    async renameWebAuthn(credentialId, name) {
        return this.client.patch(`/api/mfa/webauthn/${credentialId}`, { name });
    }
    /**
     * Delete a WebAuthn credential.
     */
    async deleteWebAuthn(credentialId) {
        return this.client.delete(`/api/mfa/webauthn/${credentialId}`);
    }
}
//# sourceMappingURL=mfa-api.js.map